import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useIntl } from 'react-intl';

import AdminReportsDataList from './DataList';
import AdminReportsChartBar from './ChartBar';
import AdminReportsChartLine from './ChartLine';
import AdminReportsChartPie from './ChartPie';

import Loading from '../../Loading';
import NothingFound from '../../NothingFound';

const AdminReportView = (props) => {
  const intl = useIntl();

  const {
    report,
    data,
    dataLoading,
  } = props;

  if (dataLoading) {
    return (
      <Loading />
    );
  }

  return (
    <div className={classnames('report-wrapper', `report-${report.id}-wrapper`)}>
      {(!data || Object.keys(data).length === 0) ? (
        <NothingFound text={intl.formatMessage({ defaultMessage: 'No data found' })} />
      ) : (
        <>
          {(report.type === 'chart' && data) && (
            <div className="report-chart">
              {report.chartType === 'bar' && (
                <AdminReportsChartBar
                  report={report}
                  data={data}
                  fullPage={true}
                />
              )}
              {report.chartType === 'line' && (
                <AdminReportsChartLine
                  report={report}
                  data={data}
                  fullPage={true}
                />
              )}
              {report.chartType === 'pie' && (
                <AdminReportsChartPie
                  report={report}
                  data={data}
                  fullPage={true}
                />
              )}
            </div>
          )}
          <AdminReportsDataList {...props} />
        </>
      )}
    </div>
  );
};

AdminReportView.propTypes = {
  report: PropTypes.object.isRequired,
  data: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
  ]).isRequired,
  dataLoading: PropTypes.bool.isRequired,
};

export default AdminReportView;
